import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { DailyReportsService } from '@/services/dailyReportsService';
import type { DailyReportsState } from '@/types/dailyReports.types';

interface DailyReportsStore extends DailyReportsState {
  // Actions
  fetchComments: () => Promise<void>;
  refreshComments: () => Promise<void>;
}

export const useDailyReportsStore = create<DailyReportsStore>()(
  devtools(
    (set, get) => ({
      // Initial state
      comments: [],
      loading: false,
      error: null,

      // Actions
      fetchComments: async () => {
        set({ loading: true, error: null });

        try {
          const comments = await DailyReportsService.getComments({
            pageNumber: 1,
            pageSize: 25,
            dateOrder: 'desc',
          });

          set({
            comments,
            loading: false,
            error: null,
          });
        } catch (error) {
          console.error('Error fetching report comments:', error);
          set({
            error: error instanceof Error ? error.message : 'Failed to fetch report comments',
            loading: false,
          });
        }
      },

      refreshComments: async () => {
        await get().fetchComments();
      },
    }),
    { name: 'DailyReportsStore' }
  )
);
